import {Component, HostBinding, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {ScreenService, AppInfoService} from './shared/services';
import config from 'devextreme/core/config';
import {locale} from 'devextreme/localization';
import {MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG} from '@azure/msal-angular';
import {
    AuthenticationResult,
    EventMessage,
    EventType,
    InteractionStatus,
    InteractionType,
    PopupRequest,
    RedirectRequest
} from '@azure/msal-browser';
import {filter, takeUntil} from 'rxjs/operators';
import DataGrid, {Properties as DataGridProperties} from 'devextreme/ui/data_grid';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    @HostBinding('class') get getClass() {
        return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
    }

    private readonly _destroying$ = new Subject<void>();
    isLoggedIn = false;

    constructor(private authService: MsalService,
                private screen: ScreenService,
                public appInfo: AppInfoService,
                private router: Router,
                @Inject(LOCALE_ID) LOCALE_ID: string,
                private msalBroadcastService: MsalBroadcastService,
                @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,) {

        locale(LOCALE_ID);
        config({defaultCurrency: 'EUR'});


        DataGrid.defaultOptions<DataGridProperties>({
            options: {
                showColumnLines: false,
                allowColumnResizing: true,
                export: {
                    formats: ['xlsx'],
                    allowExportSelectedData: false
                },
            }
        });

    }

    isAuthorized(): boolean {
        return true;
    }

    // In app.component.ts
    ngOnInit() {


        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                this.setLoginDisplay();
            });
    }

    setLoginDisplay() {
        var accounts = this.authService.instance.getAllAccounts();
        this.isLoggedIn = accounts.length > 0;

        if (!this.isLoggedIn) {
            this.login();
        }
    }


    login() {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            if (this.msalGuardConfig.authRequest) {
                this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
                    .subscribe((response: AuthenticationResult) => {
                        this.authService.instance.setActiveAccount(response.account);
                    });
            } else {
                this.authService.loginPopup()
                    .subscribe((response: AuthenticationResult) => {
                        this.authService.instance.setActiveAccount(response.account);
                    });
            }
        } else {
            if (this.msalGuardConfig.authRequest) {
                this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
            } else {
                this.authService.loginRedirect();
            }
        }
    }

    logout() {
        this.authService.logout();
    }

    ngOnDestroy() {
        this._destroying$.next(null);
        this._destroying$.complete();
    }
}

